export default "__VITE_ASSET__BiSp9lHx__"